<div class="c__header">

  @if (!isSimplified) {
    <div class="c__header-top is-text-center">
      @if (!isDevice$) {
        <sd-header-reinsurances [reinsurancesData]="deliveryContactData" />

        <div class="c__language-wrapper">
          <sd-language-selector
            [languages]="languageSelectorData.languages"
            [activeIsoCode]="languageSelectorData.activeIsoCode"
            (languageSelected)="changeLanguage($event)"
          />
        </div>
      }
    </div>
  }

  <div class="c__header-main-content" [@fadeInOut]="showPageNavigation && menuHidden && !isDevice$ ? '0' : '1'">
    <div class="c__header-content is-text-{{textConfig}}" (mouseenter)="onClickOverlay()">
      @if (isSimplified) {
        <a sd-button
          class="c__back-button"
          [isSmall]="true"
          icon="icon-arrow-left"
          (click)="goBack()"
          [isSecondary]="true"
        >
          <span>{{ (isMobile$ ? 'navigation.checkout.backMobile' : 'navigation.checkout.back') | translate}}</span>
        </a>
      }

      @if (logoLink) {
        <div class="c__logo {{ isSimplified ? 'is-simplified' : ''}}">
          <sd-link [link]="logoLink">
            <sd-icon name="icon-brand" />
            <span class="is-visually-hidden">{{'navigation.a11y.brandHomepage' | translate}}</span>
          </sd-link>
        </div>
      }

      @if (!isDevice$ && !isSimplified) {
        <sd-search
          class="c__search"
          [alpha]="menuHidden ? false : alpha"
          [searchData]="searchData?.data"
          [inputMinLength]="inputMinLength"
          [pushTemplate]="pushHeaderTemplate1"
          (clearInputSearch)="onClearInputSearch()"
          (submitInputSearch)="onSubmitSearch($event)"
          (inputSearch)="onSearch($event)"
          (openSearch)="onOpenedSearch($event)"
          (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
        >
          <ng-template #pushHeaderTemplate1>
            <ng-container *ngTemplateOutlet="pushTemplate" />
          </ng-template>
        </sd-search>
      }

      <div class="c__informations">
        @if (isDevice$ && (menuHidden || isScrolled)) {
          <button sd-button-icon
            class="c__search-btn-toggle {{alpha ? 'is-theme-light' : ''}}"
            icon="icon-magnify"
            [size]="iconSize.medium"
            (click)="toggleSearch()"
            (keydown.enter)="toggleSearch()"
          ></button>
        }

        @if (iconLinks && !isDevice$) {
          @for (iconLink of iconLinks; track iconLink) {
            @if (!iconLink.isMobile) {
              <div class="c__information">
                <sd-link
                  [icon]="iconLink.iconName"
                  [size]="iconSize.small"
                  [iconPos]="positionEnum.left"
                  [titleHidden]="true"
                  role="button"
                  customClass="has-label"
                  [buttonIconTitle]="iconLink.link?.linkName"
                  [link]="iconLink.link"
                >
                  <span class="c__icon-label">
                    {{iconLink.link?.linkName}}
                  </span>
                </sd-link>
              </div>
            }
          }
        }

        @if (dropdownHelpData && !isDevice$) {
          <sd-dropdown-help class="c__information" [links]="dropdownHelpData" />
        }

        @if (dropdownAccountData) {
          <sd-dropdown-account
            class="c__information"
            [account]="dropdownAccountData?.account"
            [isLoggedIn]="dropdownAccountData?.loggedIn"
            (signUp)="onSignUp()"
            (login)="onLogin()"
            (logout)="onLogout()"
            (isOpenedChange)="isAccountOpenedChange.emit($event)"
          />
        }

        @if (dropdownCartData) {
          <sd-dropdown-cart
            class="c__information"
            [cartData]="dropdownCartData"
            (empty)="onEmptyCart()"
            (quantity)="onQuantityChange($event)"
            (delete)="onDelete($event)"
            (promoClick)="onClickPromo($event)"
            (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
            (isOpenedChange)="isCartOpenedChange.emit($event)"
          />
        }
      </div>
    </div>

    @if (!isSimplified) {
      <sd-menu #menuComponent
        [@fadeInOut]="menuHidden && !isDevice$ ? '0' : '1'"
        class="{{showOverlay ? 'is-open' : ''}}"
        [menuData]="menuDataConfig?.menuData"
        [alpha]="alpha"
        [themesConfig]="(themesConfig === brandThemesEnum.brand) ? themesEnum.dark : themesConfig"
        [iconLinks]="iconLinks"
        [languageSelectorData]="languageSelectorData"
        [activeCatId]="menuDataConfig?.activeCatId"
        (linkClicked)="onLinkClicked($event)"
        (pushCardClicked)="onPushCardClicked($event)"
        (clickCardFrames)="onClickCardFrames($event)"
        (isMenuOpen)="onMenuOpenedChanged($event)"
        (clickNavigation)="onClickMenu($event)"
        (languageSelected)="changeLanguage($event)"
      />
    }
  </div>

  @if (!isSimplified && showPageNavigation ) {
    <sd-page-navigation
      [title]="pageNavigationData?.title"
      [product]="pageNavigationData?.product"
      [links]="pageNavigationData?.links"
      [isBundle]="isBundle"
      [@fadeInOut]="!menuHidden ? '0' : '1'"
      [isSSR]="isSSR"
      (cart)="onAddToCart()"
      (notify)="onNotify()"
      (favorite)="onAddToFavorite()"
      (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
    />
  }

  @if (isDevice$ && !isSimplified) {
    <sd-search
      [@fadeInOut]="showPageNavigation && menuHidden ? '0' : '1'"
      class="c__search"
      [openMobileSearch]="openMobileSearch.asObservable()"
      [hasFormToggle]="!(menuHidden || isScrolled)"
      [searchData]="searchData?.data"
      [pushTemplate]="pushHeaderTemplate2"
      (submitInputSearch)="onSubmitSearch($event)"
      (inputSearch)="onSearch($event)"
      (openSearch)="onOpenedSearch($event)"
      (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
    >
      <ng-template #pushHeaderTemplate2>
        <ng-container *ngTemplateOutlet="pushTemplate" />
      </ng-template>
    </sd-search>
  }
</div>

@if (showOverlay) {
  <div class="c__menu-overlay" (click)="onClickOverlay()" (mousemove)="onClickOverlay()"></div>
}
